import { SettingsCardStatusType, SettingsCardSvgHeader } from "../types";
import styles from "../settings-card.css";

export const getStatusTypeClass = (statusType: SettingsCardStatusType) => {
    switch (statusType) {
        case "DEFAULT":
            return styles.default;

        case "INVALID":
            return styles.invalid;

        case "SEVERE":
            return styles.severe;

        case "VALID":
            return styles.valid;

        default:
            throw new Error("Invalid status type");
    }
};

export const isSvgHeader = (value: any): value is SettingsCardSvgHeader => {
    return value && typeof value.svg === "string";
};
